import React from "react"
import { Navigate } from "react-router-dom"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
import Configs from "../config"
import VerifyCode from "pages/Authentication/VerifyOTP"
import ResetPassword from "pages/Authentication/ResetPassword"
import SalesRevenue from "pages/SalesRevenue"
import GMP from "pages/GMP"
import OEEIndex from "pages/OEE"
import PLIndex from "pages/P&L"
import RangesIndex from "pages/Ranges"
import SuasageCategory from "pages/Suasage"
import AuditLogs from "pages/AuditLogs"
import HistoryPage from "pages/Dashboard/HistoryPage"
import NetMarginPage from "pages/NetMargin"
import SalesReport from "pages/SalesReport/salesReport"

const authProtectedRoutes = [
  { path: `${Configs.appurl}dashboard`, component: <Dashboard /> },
  { path: `${Configs.appurl}dashboard-history`, component: <HistoryPage /> },
  { path: `${Configs.appurl}sales-Revenue`, component: <SalesRevenue /> },
  { path: `${Configs.appurl}gmp`, component: <GMP /> },
  { path: `${Configs.appurl}oee`, component: <OEEIndex /> },
  { path: `${Configs.appurl}plcharts`, component: <PLIndex /> },
  { path: `${Configs.appurl}guage-range`, component: <RangesIndex /> },
  { path: `${Configs.appurl}suasage`, component: <SuasageCategory /> },
  { path: `${Configs.appurl}logs`, component: <AuditLogs /> },
  { path: `${Configs.appurl}net-margin`, component: <NetMarginPage /> },
  { path: `${Configs.appurl}sales-report`, component: <SalesReport /> },
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: `${Configs.appurl}`,
    exact: true,
    component: <Navigate to="dashboard" />,
  },
]

const publicRoutes = [
  { path: `${Configs.appurl}logout`, component: <Logout /> },
  { path: `${Configs.appurl}login`, component: <Login /> },
  { path: `${Configs.appurl}forgot-password`, component: <ForgetPwd /> },
  { path: `${Configs.appurl}verify-code`, component: <VerifyCode /> },
  { path: `${Configs.appurl}reset-password`, component: <ResetPassword /> },
]

export { authProtectedRoutes, publicRoutes }
